import { Box, Typography, styled } from "@mui/material";
import React, { useState } from "react";
import ContactsSearchFunctional from '../Contacts/ContactsSearchFunctional'
import { useSelector } from "react-redux";
import SelectedContactFunctional from '../Contacts/SelectedContactFunctional'
import {
    newContactAddedStatus,
    syncContactsWithCache,
} from "../../../state/actions/contacts";
import {
    getDataFromLFStorage,
    LFStorageKeys,
    saveDataInLFStorage,
} from "../../../services/storage/LFStorage";
import Scrollbars from "react-custom-scrollbars-2";
import store from "../../../state/configureStore";
import { showToast } from "../../../components/ui/toaster";
import { addContacts, search } from "../../../services/clients/ContactsService";

const StyledTypography = styled(({ isBold, ...other }) => (
    <Typography {...other} />
))(({ isBold = false }) => ({
    fontSize: '16px',
    fontFamily: 'Figtree-Regular',
    color: '#404585',
    fontWeight: isBold ? '600' : 'normal'
}))

const ConnectUserFunctional = (props) => {
    const selectedDomain = useSelector((state) => state.domain.selectedDomainDetails);
    const [showSearchResults, setShowSearchResults] = useState(false);
    const [contacts, setContacts] = useState(null);
    const userDomain = selectedDomain?.userDomain || '';
    const [spinner, setSpinner] = useState(false);

    const searchContacts = (searchText) => {
        if (searchText) {
            search(searchText, selectedDomain?.userDomain).then(
                (contacts) => {
                    let newContacts = [...contacts];
                    newContacts.forEach((element) => {
                        element.sentRequest = false;
                        element.spinner = false;
                    });
                    setContacts(newContacts);
                    setShowSearchResults(true);
                }
            );
        } else {
            setShowSearchResults(false);
        }
    }

    const sendTheRequest = async (contact, index) => {
        let data = [];
        data?.push(contact);
        let newContact = [...contacts];
        newContact[index].sending = true;
        newContact[index].spinner = true;
        setContacts([...newContact]);
        handleAddContacts(data, index);

        let contactsList =
            (await getDataFromLFStorage(
                `${LFStorageKeys.CONTACTS}_${userDomain}`
            )) || [];

        if (contactsList) {
            contactsList?.contacts?.push({
                userId: contact,
                userName: newContact[index].userName,
                waitingForConfirmation: true,
            });
            saveDataInLFStorage(
                `${LFStorageKeys.CONTACTS}_${userDomain}`,
                contactsList
            );
            store.dispatch(syncContactsWithCache(contactsList));
        }
    };

    const handleAddContacts = (users, ind) => {
        console.log("%c Adding contacts", "color: grey;", users);
        store.dispatch(newContactAddedStatus(false));
        addContacts(users, "search", userDomain)
            .then(() => {
                store.dispatch(newContactAddedStatus(true));
                setSpinner(false);
                let newContact = [...contacts];
                newContact[ind].sentRequest = true;
                newContact[ind].spinner = false;
                setContacts(newContact);
            })
            .catch((error) => {
                console.log("error ", error);
                setSpinner(false);
                showToast('error', "Error while adding the contacts. Please try again later.");
            });
    };

    return <Box>
        <StyledTypography isBold={true}>Connect with users</StyledTypography>
        <Box sx={{ marginLeft: '-18px' }}>
            <ContactsSearchFunctional search={(searchText) => searchContacts(searchText)} parentComponent='addNewContact' />
        </Box>
        {!showSearchResults && <img loading="lazy" src='/img/no-contacts-illustration.svg' width="100%" style={{ marginRight: '0.5rem' }} />}
        {showSearchResults && (contacts && contacts.length > 0) && <Scrollbars autoHide style={{ height: `23rem` }}>
            {contacts.map((contact, index) => (
                <SelectedContactFunctional
                    index={index}
                    contact={contact}
                    requestSent={contact.sentRequest}
                    spinner={contact.spinner}
                    sending={contact.sending}
                    allProfileImages={props.allProfileImages}
                    sendTheRequest={sendTheRequest}
                    userDomain={userDomain}
                />
            ))}
        </Scrollbars>}
        {showSearchResults && (!contacts || contacts?.length === 0) && <StyledTypography isBold={false} sx={{ textAlign: 'center' }}>
            No Contacts found for the given search criteria
        </StyledTypography>}
    </Box>
}

export default ConnectUserFunctional;